import fetchApiWithAuth from "./fetch";

export type Integration = "tg" | "max";

export type NotificationTopicInfo = {
  id: string;
  label: string;
  description: string;
  defaultOn: boolean;
};

export interface NotificationSubscription {
  id: number;
  name: string;
  integration: Integration;
  is_active: boolean;
  topics: string[];
  created_at: string;
}

export const getNotificationTopics = async (): Promise<
  NotificationTopicInfo[]
> => {
  const res = await fetchApiWithAuth("/api/notifications/topics");
  if (!res.ok) throw new Error("topics failed");
  const data = (await res.json()) as { topics: NotificationTopicInfo[] };
  return data.topics;
};

export const getSubscriptions = async (): Promise<NotificationSubscription[]> => {
  const res = await fetchApiWithAuth("/api/notifications/subscriptions");
  return res.json();
};

export const addSubscription = async (
  chat_id: string,
  integration: Integration,
  name: string,
  topics: string[]
): Promise<NotificationSubscription> => {
  const res = await fetchApiWithAuth("/api/notifications/subscriptions", {
    method: "POST",
    body: JSON.stringify({ chat_id, integration, name, topics }),
  });
  if (res.status === 409) {
    throw Object.assign(new Error("Duplicate"), { status: 409 });
  }
  if (!res.ok) {
    throw Object.assign(new Error("Request failed"), { status: res.status });
  }
  return res.json();
};

export const updateSubscription = async (
  id: number,
  patch: { is_active?: boolean; topics?: string[] }
): Promise<NotificationSubscription> => {
  const res = await fetchApiWithAuth(`/api/notifications/subscriptions/${id}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
  if (!res.ok) {
    throw Object.assign(new Error("Request failed"), { status: res.status });
  }
  return res.json();
};

export const toggleSubscription = async (
  id: number,
  is_active: boolean
): Promise<NotificationSubscription> => updateSubscription(id, { is_active });

export const deleteSubscription = async (id: number): Promise<void> => {
  await fetchApiWithAuth(`/api/notifications/subscriptions/${id}`, {
    method: "DELETE",
  });
};

export const testSubscription = async (id: number): Promise<void> => {
  const res = await fetchApiWithAuth(`/api/notifications/subscriptions/${id}/test`, {
    method: "POST",
  });
  if (!res.ok) throw new Error("Test failed");
};
